import { Grid, Card, Typography, Backdrop, CircularProgress, TextareaAutosize, Box } from "@mui/material";
import { useForm, Controller } from 'react-hook-form';
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { toast } from 'react-toastify';
import { handleErrors } from "common.js";
import configurations from "config";
import { React, useEffect, useState } from "react";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import { useParams } from 'react-router-dom';
import { VENDOR_TICKET } from "constants";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import MDInput from "components/MDInput";
import { convertToBase64 } from "common";
import { IconButton, Icon } from "@mui/material";
import ImagePopup from "layouts/components/ImagePopup.js";

export default function ViewTicket() {
  const id = useParams().id;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const baseUrl = configurations.baseUrl;
  const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
  const [ticketData, setData] = useState([]);
  const [ticketReplies, setTicketReplies] = useState([]);
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [confirmTicketId, setConfirmTicketId] = useState(0);
  const [mediaImages, setMediaImages] = useState([]);
  const [imagePopup, setImagePopup] = useState(false);
  const [startIndex, setStartIndex] = useState(0);

  const { register, setValue, getValues, setError, control, handleSubmit, formState: { errors }, } = useForm();

  const data = () => {
    setIsLoading(true);
    toast.dismiss();
    axios({
      url: baseUrl + "/ticket/view?id=" + id,
      method: "GET",
      headers: {
        Authorization: bearerToken,
        function: azureFunctionVendorFrontendKey
      }
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          let mainTicketImages = [];
          let replyImages = [];
          const responseData = response.data;
          setData(response.data);
          mainTicketImages = responseData.data.images
            ? JSON.parse(responseData.data.images).map((image) => ({
              original: image.mediaURL,
              thumbnail: image.mediaURL,
            }))
            : [];

          if (responseData.data && responseData.data.replies && responseData.data.replies.length > 0) {
            setTicketReplies(responseData.data.replies.reverse());
            const replies = responseData.data.replies || [];
            replyImages = replies
              .filter((reply) => reply.images)
              .flatMap((reply) => {
                const replyId = reply.id;
                return JSON.parse(reply.images).map((image) => ({
                  original: image.mediaURL,
                  thumbnail: image.mediaURL,
                  replyId: replyId,
                }));
              });
          }
          const allImages = [...mainTicketImages, ...(replyImages.length > 0 ? replyImages : [])];
          setMediaImages(allImages);
        }
        else {
          toast.error(t(message));
          const redirectTimeout = setTimeout(() => {
            clearTimeout(redirectTimeout);
            navigate("/tickets/list/");
          }, 3000);
        }
      }
      else {
        toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
        const redirectTimeout = setTimeout(() => {
          clearTimeout(redirectTimeout);
          navigate("/tickets/list/");
        }, 3000);
      }
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  const handleConfirmationDialogOpen = () => {
    setConfirmationDialogOpen(true);
  };

  const handleConfirmationDialogClose = () => {
    setConfirmationDialogOpen(false);
    setConfirmTicketId(0);
  };

  const handleConformationClose = () => {
    closeTicket(confirmTicketId);
  }

  const closeTicket = (ticketId) => {

    setIsLoading(true);
    toast.dismiss();

    axios.post(baseUrl + '/ticket/close', { ticketId: id }, {
      headers: {
        Authorization: bearerToken,
        function: azureFunctionVendorFrontendKey,
      }
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200 && response.data.status == 0)
        (
          toast.error(t(response.data.message))
        )
      else {
        toast.success(t(response.data.message))
        const updatedTicketData = { ...ticketData };
        updatedTicketData.data.status = VENDOR_TICKET.CLOSED;
        setData(updatedTicketData);
      }
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
    setConfirmationDialogOpen(false);
  }

  const confirmationModelLoad = () => {
    return (
      <Dialog open={confirmationDialogOpen} onClose={handleConfirmationDialogClose}>
        <DialogTitle>{t("confirmCloseTicket")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("ticketCloseMessage")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleConfirmationDialogClose} variant="contained" color="secondary" disableRipple>
            {t("cancel")}
          </MDButton>
          <MDButton onClick={handleConformationClose} variant="contained" color="primary" disableRipple>
            {t("confirmClose")}
          </MDButton>
        </DialogActions>
      </Dialog>
    );
  }


  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const fileName = file.name;

    if (file) {
      const base64 = await convertToBase64(file);
      const fileData = { imageData: base64, name: fileName };
      setIsLoading(true);
      axios.post(baseUrl + '/ticket/create-ticket-attachment', fileData, {
        headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
      })
        .then((response) => {
          setIsLoading(false);
          if (response.status == 200) {
            const status = response.data.status;
            const message = response.data.message;
            if (status == 1) {
              let imageInfo = response.data.data;
              imageInfo.fileName = fileName;
              setValue('images', JSON.stringify([imageInfo]));
              toast.success(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
            }
            else {
              if (message != '') {
                setValue('images', '');
                toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
              }
            }
          }
          else {
            toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
          }
        })
        .catch(error => {
          setIsLoading(false);
          handleErrors(error, t, navigate);
        });
    }
  }

  const handleFileDelete = async (e) => {
    let fileInfo = JSON.parse(getValues('images'))[0]
    const fileData = { azureImageId: fileInfo.azureImageId, mediaURL: fileInfo.mediaURL };
    setIsLoading(true);
    axios.post(baseUrl + '/ticket/delete-ticket-attachment', fileData, {
      headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
    })
      .then((response) => {
        setIsLoading(false)
        if (response.status == 200) {
          const status = response.data.status;
          const message = response.data.message;
          if (status == 1) {
            setValue('images', '');
            toast.success(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
          }
          else {
            if (message != '')
              toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
          }
        }
        else {
          toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
        }
      }).catch(error => {
        setIsLoading(false)
        handleErrors(error, t, navigate);
      });
  }


  useEffect(() => {
    setValue('id', id);
    data();
  }, []);

  const handleImagePopupOpen = (index) => {
    setStartIndex(index);
    setImagePopup(true)
  }

  const onSubmit = async (data) => {
    setIsLoading(true)
    axios.post(baseUrl + '/ticket/reply', data, {
      headers: {
        Authorization: bearerToken,
        function: azureFunctionVendorFrontendKey,
      }
    })
      .then((response) => {
        setIsLoading(false);
        if (response.status == 200) {
          const status = response.data.status;
          const message = response.data.message;
          if (status == 1) {
            toast.success(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
            const redirectTimeout = setTimeout(() => {
              clearTimeout(redirectTimeout);
              navigate('/tickets/list/');
            }, 2000);
          }
          else {
            toast.error(t(response.data.message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
            if (response && response.data && response.data.errors) {
              const errorData = response.data.errors;
              errorData.forEach((error) => {
                setError(error.field, {
                  type: 'server',
                  message: t(error.errors[0])
                });
              });
            }
          }
        }
        else {
          toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
        }
      }).catch(error => {
        setIsLoading(false)
        handleErrors(error, t, navigate);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t("viewTickets") + '  #' + id} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
      <MDBox className="ContentSectionBox">
        <Grid container spacing={2}>
          {(ticketData.data) ?
            <>
              <Grid item xs={12} sm={3} md={3} >
                <Box pl={2}>
                  <Typography variant="body2">{t('subject')}</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={9} md={9} >
                <Box pl={2}>
                  <Typography variant="body2">
                    {ticketData.data.subject}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={3} md={3} >
                <Box pl={2}>
                  <Typography variant="body2">  {t('message')}</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={9} md={9} >
                <Box pl={2}>
                  <Typography variant="body2" mb={1}>
                    {ticketData.data.content}
                  </Typography>
                </Box>
                {(ticketData && ticketData.data && ticketData.data.images) ?
                  <Box pl={2}>
                    <Typography variant="body2">
                      <MDBox component="img" src={JSON.parse(ticketData.data.images)[0].mediaURL} onClick={(e) => handleImagePopupOpen(0)} className="customFieldImage" />
                    </Typography>
                  </Box>
                  :
                  null}
              </Grid>
              <Grid item xs={12} sm={3} md={3} >
                <Box pl={2}>
                  <Typography variant="body2">  {t('createdAt')}</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={9} md={9} >
                <Box pl={2}>
                  <Typography variant="body2">
                    {new Date(ticketData.data.createdAt).toLocaleDateString()}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={3} md={3} >
                <Box pl={2}>
                  <Typography variant="body2">{t('status')}</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={9} md={9} >
                <Box pl={2}>
                  <Typography variant="body2 awaitingStatus">
                    {(ticketData.data.status == VENDOR_TICKET.CLOSED) ?
                      (ticketData.data.closedBy >= 1) ?
                        <span className={'ticketStatus' + ticketData.data.status}>{t('closedByAdmin')}</span>
                        :
                        <span className={'ticketStatus' + ticketData.data.status}>{t('closedByVendor')}</span>
                      : (ticketData.data.status == VENDOR_TICKET.AWAITING_ADMIN_REPLY) ?
                        <span className={'ticketStatus' + ticketData.data.status}>{t('awaitingAdminReply')}</span>
                        :
                        <span className={'ticketStatus' + ticketData.data.status}>{t('awaitingVendorReply')}</span>
                    }
                  </Typography>
                  {(ticketData.data.status == VENDOR_TICKET.AWAITING_ADMIN_REPLY || ticketData.data.status == VENDOR_TICKET.AWAITING_VENDOR_REPLY) ?
                    <>
                      <MDButton className="ticketClose" disableRipple onClick={(event) => {
                        event.preventDefault();
                        setConfirmTicketId(ticketData.id);
                        handleConfirmationDialogOpen();
                      }} color="primary">{t("close")}</MDButton>
                      {confirmationModelLoad()}
                    </>
                    : null}
                </Box>
              </Grid>
              {(ticketData.data.status == VENDOR_TICKET.CLOSED) ?
                <>
                  <Grid item xs={12} sm={3} md={3} >
                    <Box pl={2}>
                      <Typography variant="body2">  {t('closedAt')}</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={9} md={9} >
                    <Box pl={2}>
                      <Typography variant="body2">
                        {new Date(ticketData.data.updatedAt).toLocaleDateString()}
                      </Typography>
                    </Box>
                  </Grid>
                </>
                : null
              }
            </>
            :
            null}
        </Grid>
      </MDBox>
      {(ticketData.data && ticketData.data.status != VENDOR_TICKET.CLOSED) ?
        <MDBox >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} >
              <Card className="ContentSectionBoxPT">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Grid item xs={12} sm={12} md={12} >
                    <Box pl={2}>
                      <Typography variant="h5" paddingTop={1} paddingBottom={2}>
                        {t('replyTicket')}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} >
                    <Box pl={2}>
                      <Controller
                        name="content"
                        control={control}
                        defaultValue=""
                        rules={{ required: { value: true, message: t('contentCannotBeEmpty') } }} // Add the required validation rule
                        render={({ field }) => (
                          <TextareaAutosize
                            {...field}
                            minRows={3}
                            maxRows={6}
                            placeholder={t('writeYourComment')}
                            className="replyTextArea"
                          />
                        )}
                      />
                      {errors.content && (<span className="errorMsg FloatRight">{errors.content.message}</span>)}
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <Box pl={2}>
                      {getValues('images') ?
                        <>
                          <MDBox component="img" src={JSON.parse(getValues('images'))[0].mediaURL} className="customFieldImage" />
                          <IconButton
                            className="PositionAbsolute"
                            size="small"
                            disableRipple
                            variant="contained"
                            onClick={(e) => { handleFileDelete(e) }}
                          >
                            <Icon className="closeIcon">close</Icon>
                          </IconButton>
                        </>
                        :
                        <MDInput
                          type="file"
                          name="image"
                          className=""
                          InputProps={{
                            classes: { root: "inputBoxStyle replyFile" },
                          }}
                          onChange={((e) => {
                            e.stopPropagation()
                            const file = e.target.files[0];
                            if (file) {
                              handleFileUpload(e);
                            }
                          })}
                          fullWidth />
                      }
                      {errors.images && (<span className="errorMsg FloatRight">{errors.images.message}</span>)}
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} >
                    <Box pl={2} mb={2}>
                      <MDButton type="submit" variant="contained" color="primary" disableRipple >{t('reply')}</MDButton>
                    </Box>
                  </Grid>
                </form>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        :
        null}

      <MDBox className="ContentSectionBoxPT">
        {(ticketData.data && ticketData.data.replies.length > 0) ?
          <>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} >
                <Box pl={2}>
                  <Typography variant="h5">{t('replies')}</Typography>
                </Box>
              </Grid>
            </Grid>
            {ticketReplies.map((reply) => (
              <Grid container key={reply.id} className="eachTicketRow">
                <Grid item xs={12} sm={12} md={12} className={'eachTicketColumn'}>
                  <Box pl={(reply.repliedBy >= 1) ? 5 : 2} >
                    <Typography variant="body2" className="dateTimeTicket">
                      <span className={(reply.repliedBy >= 1) ? 'nameTicketAdmin' : 'nameTicketVendor'}> {(reply.repliedBy >= 1) ? t('admin') : t('vendor')}</span>
                    </Typography>
                    <Typography variant="body2" className={(reply.repliedBy >= 1) ? 'rightTicket' : 'leftTicket'}>
                      <span className="replyContent"> {reply.content}</span>
                      {(reply && reply.images && JSON.parse(reply.images)[0].mediaURL) ?
                        <span >
                          <MDBox component="img" src={JSON.parse(reply.images)[0].mediaURL}
                            onClick={(e) => {
                              const replyId = reply.id;
                              const indexOfImage = mediaImages.findIndex((image) => image.replyId === replyId);
                              handleImagePopupOpen(indexOfImage);
                            }}
                            className="customFieldImage" />
                        </span>
                        :
                        null}
                      <span className="timeClassTicket">{new Date(reply.createdAt).toLocaleDateString()} : {new Date(reply.createdAt).toLocaleTimeString()}</span>
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            ))}
          </>
          :
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3} md={3} >
              <Box pl={2}>
                <Typography variant="h5">{t('noRepliesYet')}</Typography>
              </Box>
            </Grid>
          </Grid>
        }
      </MDBox>

      <ImagePopup
        imagePopup={imagePopup}
        setImagePopup={setImagePopup}
        mediaImages={mediaImages}
        startIndex={startIndex}
      />

    </DashboardLayout>
  );
}
